import { render, staticRenderFns } from "./custom1996568979237310465.vue?vue&type=template&id=2fd55221&scoped=true&"
import script from "./custom1996568979237310465.vue?vue&type=script&lang=js&"
export * from "./custom1996568979237310465.vue?vue&type=script&lang=js&"
import style0 from "./custom1996568979237310465.vue?vue&type=style&index=0&id=2fd55221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd55221",
  null
  
)

export default component.exports